<div *ngIf="state?.available" class="color-scheme" role="group" [attr.aria-label]="'Theme' | tt">
	<p class="color-scheme__label">{{ 'Theme' | tt }}</p>
	<div class="color-scheme__options">
		<button *ngFor="let option of options"
		        type="button"
		        class="color-scheme__option"
		        [class.color-scheme__option--active]="state.preference === option.value"
		        [attr.aria-pressed]="state.preference === option.value"
		        (click)="select(option.value)">
			{{ option.label | tt }}
		</button>
	</div>
	<p *ngIf="!isNds3Page" class="color-scheme__hint">{{ 'Applies to pages in the new design' | tt }}</p>
</div>
